import { render, staticRenderFns } from "./ContaAzulAuth.vue?vue&type=template&id=6ad4a47e&scoped=true"
import script from "./ContaAzulAuth.vue?vue&type=script&lang=js"
export * from "./ContaAzulAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4a47e",
  null
  
)

export default component.exports